import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SnackbarService } from "src/app/core/service/snackbar.service";
import { BillDTO } from "src/app/data/schema/Billing/Bills/BillDTO";
import { ApiBillingBillsService } from "src/app/data/service/billing/api-billing-bills.service";

@Component({
    selector: "app-cancel-bill",
    templateUrl: "./cancel-bill.component.html",
    styleUrls: ["./cancel-bill.component.scss"]
})
export class CancelBillComponent implements OnInit, OnDestroy {
    cancelBillForm: UntypedFormGroup;
    comments: string;
    isLoading: boolean;

    private _unsubscribeAll: Subject<any>;

    constructor(
        private _formBuilder: UntypedFormBuilder,
        private _apiBillingBillsService: ApiBillingBillsService,
        private dialogRef: MatDialogRef<CancelBillComponent>,
        private _translateService: TranslateService,
        private _snackbarService: SnackbarService,
        @Inject(MAT_DIALOG_DATA) public data: { bill: BillDTO }
    ) {
        this.comments = "";
        this.isLoading = false;

        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.cancelBillForm = this.createCancelBillForm();
    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    createCancelBillForm(): UntypedFormGroup {
        return this._formBuilder.group({
            comments: ["", Validators.compose([Validators.required, Validators.maxLength(100)])]
        });
    }

    cancelBillClick(): void {
        this.isLoading = true;

        this._apiBillingBillsService
            .cancel(this.data.bill.id, this.comments)
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(
                () => {
                    this._translateService
                        .get("BILLING.CANCEL_BILLING.SUCCESS_MESSAGE")
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe((res) => {
                            this._snackbarService.showMessage(res);
                        });
                    this.dialogRef.close(true);
                },
                (error) => {
                    this.isLoading = false;
                    this._translateService
                        .get("BILLING.CANCEL_BILLING.ERROR_MESSAGE")
                        .pipe(takeUntil(this._unsubscribeAll))
                        .subscribe((res) => {
                            this._snackbarService.showMessage(res);
                        });
                    console.log(error);
                },
                () => {
                    this.isLoading = false;
                }
            );
    }

    public close(): void {
        this.dialogRef.close(false);
    }
}
